var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivRT" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          return _vm.cerrarOperacion()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.esEdicion
                            ? "Editar Grupo de Interés"
                            : "Ver Detalle Grupo de Interés"
                        ) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.e1 != 1,
                                  expression: "e1 != 1"
                                }
                              ],
                              staticClass: "btn-volver",
                              attrs: {
                                disabled: _vm.e1 <= 1 || _vm.btnBloquear
                              },
                              on: {
                                click: function($event) {
                                  _vm.e1 -= 1
                                  _vm.btnText = "Continuar"
                                  _vm.btnClass = "btn-continuar"
                                }
                              }
                            },
                            [_vm._v("Volver")]
                          )
                        : _vm._e(),
                      _vm._v("  \n          "),
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cierraMenu()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.asociarCliente.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.asociarClienteVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (asociarCliente.visible && esEdicion) ||\n                  (asociarClienteVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.asociarCliente.step
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cierraMenu()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v("Asociar Clientes")]),
                              _c("v-icon", [_vm._v("group")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass: "h2_title",
                                              staticStyle: {
                                                "margin-top": "12px!important",
                                                "font-weight": "normal"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Información General\n                    "
                                              )
                                            ]
                                          ),
                                          _c("v-divider")
                                        ],
                                        1
                                      ),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Código",
                                                  counter: 80,
                                                  type: "text",
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.editedItem.id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.id"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|GrupoInteresNombreUnicoEditar|max:80",
                                                    expression:
                                                      "\n                          'required|GrupoInteresNombreUnicoEditar|max:80'\n                        "
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Nombre",
                                                  counter: 80,
                                                  "data-vv-name": "nombre",
                                                  type: "text",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "nombre"
                                                  ),
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.nombre,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "nombre",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.nombre"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "max:200",
                                                    expression: "'max:200'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Descripción",
                                                  counter: 200,
                                                  "data-vv-name": "descripcion",
                                                  type: "text",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.asociarCliente.step &&
                            ((_vm.asociarCliente.visible && _vm.esEdicion) ||
                              (_vm.asociarClienteVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == asociarCliente.step &&\n              ((asociarCliente.visible && esEdicion) ||\n                (asociarClienteVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-container",
                                {
                                  attrs: {
                                    "grid-list-md": "",
                                    "text-xs-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "h2_title" },
                                                [_vm._v("Asociar Clientes")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "prepend-icon": "group",
                                              color: "primary",
                                              label: "Buscar...",
                                              "append-icon": "search"
                                            },
                                            on: {
                                              input:
                                                _vm.onFilterTextBoxChangedEdicion
                                            },
                                            model: {
                                              value: _vm.buscarCliente,
                                              callback: function($$v) {
                                                _vm.buscarCliente = $$v
                                              },
                                              expression: "buscarCliente"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md12: "" } },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("ag-grid-vue", {
                                                staticClass:
                                                  "ag-theme-material",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "380px",
                                                  "font-family":
                                                    "'Asap', sans-serif"
                                                },
                                                attrs: {
                                                  columnDefs:
                                                    _vm.columnDefsCliente,
                                                  rowData: _vm.clientesRespaldo,
                                                  rowSelection: "multiple",
                                                  rowMultiSelectWithClick:
                                                    "false",
                                                  pagination: "true",
                                                  paginationPageSize: "10",
                                                  suppressRowClickSelection:
                                                    "true",
                                                  sideBar: _vm.sideBar,
                                                  localeText: _vm.localeText,
                                                  onGridReady: _vm.onGridReady,
                                                  postProcessPopup:
                                                    _vm.onClickCell,
                                                  suppressCopyRowsToClipboard:
                                                    "true",
                                                  getRowNodeId:
                                                    _vm.getRowNodeId,
                                                  suppressCsvExport: true,
                                                  suppressExcelExport: true,
                                                  isExternalFilterPresent:
                                                    _vm.isExternalFilterPresentCliente,
                                                  doesExternalFilterPass:
                                                    _vm.doesExternalFilterPassCliente
                                                },
                                                on: {
                                                  "selection-changed": function(
                                                    $event
                                                  ) {
                                                    return _vm.onSelectionChangeEdicionTipoLugar(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Grupo de Interés",
            nombreEntidad: _vm.editedItem.nombre
          }),
          mensaje: _vm.$t("mensajes.crud.editar.mensaje", {
            entidad: "el Grupo de Interés"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar"),
          width: 390
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }